var taricPrint = angular.module('taric.report', ['report.pt', 'taric.relief.search', 'taric.relief.view', 'taric.mlr.search', 'taric.measure.report', 'taric.measure.amendments']);
taricPrint.config(function ($stateProvider) {
    $stateProvider.state('taric.report', {
        abstract: true,
        url: '/report',
        template: '<ui-view></ui-view>'
    }).state('taric.report.pt', {
        url: '/pt?sd&cc&l&frm',
        templateUrl: 'taric/report/pt/printed-taric-search.tmpl.html',
        controller : 'PrintedTaricController as printedTaricCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: function($stateParams, $filter, $translate, PrintedTaricModel, CommonHelper){
                if ($stateParams.frm !== 'ccLookup') {
                    PrintedTaricModel.reset();
                }
                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        PrintedTaricModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.cc){
                    PrintedTaricModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/pt');
            },
            setupMenu: function (MenuModel) {
            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    }).state('taric.report.relief', {
        abstract: true,
        url: '/reliefcode',
        template: '<ui-view></ui-view>'
    }).state('taric.report.relief.search', {
        url: '/search?sd&rt&rc&l&frm',
        templateUrl: 'taric/report/relief/search/relief-code-search.tmpl.html',
        controller : 'ReliefCodeController as reliefCodeCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: function(ReliefReportModel, $stateParams, $translate, CommonHelper){
                if ($stateParams.frm !== 'taric.report.relief.view') {
                    ReliefReportModel.reset();
                }
                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        ReliefReportModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.rt){
                    ReliefReportModel.getSearchCriteria().reliefCodeType = $stateParams.rt;
                }
                if ($stateParams.rc){
                    ReliefReportModel.getSearchCriteria().reliefCode = $stateParams.rc;
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/relief/search');
            },
            setupMenu: function (MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            },
            reliefCodeTypes: function(ReliefReportModel){
                var searchCriteria = ReliefReportModel.getSearchCriteria();
                return ReliefReportModel.loadReliefCodeTypes(searchCriteria.simulationDate);
            }
        }
    }).state('taric.report.relief.view', {
        url: '/view?cd&sd',
        templateUrl: 'taric/report/relief/view/relief-code-view.tmpl.html',
        controller : 'ReliefCodeViewController as reliefCodeViewCtrl',
        resolve: {
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/relief/view');
            },
            setupMenu: function (MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            },
            reliefCodeDetail : function($stateParams, ReliefReportModel, CommonHelper){
                var reliefCode = $stateParams.cd;
                var simulationDate = new Date();
                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                if (inputDate) {
                    simulationDate = inputDate;
                }
                return ReliefReportModel.getReliefCodeDetail(reliefCode, simulationDate);
            }
        }
    }).state('taric.report.mlr', {
        url: '/mlr?sd&rp&rn&ry&ccs&cce&frm&&cc&ccField',
        templateUrl: 'taric/report/mlr/mlr-search.tmpl.html',
        controller : 'MlrSearchController as mlrSearchCtrl',
        reloadOnSearch: false,
        resolve: {
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/mlr');
            },
            initializeData: function($stateParams, MlrReportModel, $translate, CommonHelper){

                if ($stateParams.frm !== 'ccLookup') {
                    MlrReportModel.reset();
                }

                //In the case of returning back from lookup commodity code screen, do not reset data
                if ($stateParams.ccField && $stateParams.cc){
                    if ($stateParams.ccField === 'commodityCodeFrom'){
                        MlrReportModel.getSearchCriteria().commodityCodeFrom = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeTo'){
                        MlrReportModel.getSearchCriteria().commodityCodeTo = $stateParams.cc;
                    }
                }

                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        MlrReportModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }

                if ($stateParams.rp) {
                    MlrReportModel.getSearchCriteria().regulationPrefix = $stateParams.rp;
                }
                if ($stateParams.rn) {
                    MlrReportModel.getSearchCriteria().regulationNumber = $stateParams.rn;
                }
                if ($stateParams.ry) {
                    MlrReportModel.getSearchCriteria().regulationYear = $stateParams.ry;
                }
                if ($stateParams.ccs) {
                    MlrReportModel.getSearchCriteria().commodityCodeFrom = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MlrReportModel.getSearchCriteria().commodityCodeTo = $stateParams.cce;
                }
            },
            setupMenu: function (MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    }).state('taric.report.measure', {
        url: '/measure?frm&cc&ccField&ds&de&ccs&cce&d&co&mt&ad&fn&ce&gnd&add&fnd&ced&gad&ded&l',
        templateUrl: 'taric/report/measure/measure-report-search.tmpl.html',
        controller : 'MeasureReportController as measureReportCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: function($stateParams, $filter, $translate, MeasureReportModel, CommonHelper){
                if ($stateParams.frm !== 'ccLookup' &&
                        $stateParams.frm !== 'adcoLookup' &&
                        $stateParams.frm !== 'footnoteLookup' &&
                        $stateParams.frm !== 'certificateLookup' &&
                        $stateParams.frm !== 'ccView') {
                    MeasureReportModel.reset();
                } else if ($stateParams.frm === 'ccLookup' ||
                            $stateParams.frm === 'adcoLookup' ||
                            $stateParams.frm === 'footnoteLookup' ||
                            $stateParams.frm === 'certificateLookup') {
                    MeasureReportModel.resetSearchResult();
                }
                if ($stateParams.ccField && $stateParams.cc){
                    if ($stateParams.ccField === 'commodityCodeRangeStart'){
                        MeasureReportModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeRangeEnd'){
                        MeasureReportModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                    }
                }
                if ($stateParams.ds){
                    var startDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (startDate) {
                        MeasureReportModel.getSearchCriteria().startDate = startDate;
                    }
                }
                if ($stateParams.de){
                    var endDate = CommonHelper.parseInputDate($stateParams.de);
                    if (endDate) {
                        MeasureReportModel.getSearchCriteria().endDate = endDate;
                    }
                }
                if ($stateParams.ccs) {
                    MeasureReportModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MeasureReportModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                }
                if ($stateParams.d) {
                    if ($stateParams.d === 'I' || $stateParams.d === 'E' || $stateParams.d === 'B'){
                        MeasureReportModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.co) {
                    MeasureReportModel.getSearchCriteria().country = $stateParams.co;
                }
                if ($stateParams.mt) {
                    var measureTypes = $stateParams.mt.split(',');
                    for (let i = 0; i < measureTypes.length; i++) {
                        if (MeasureReportModel.getSearchCriteria().measureTypes.indexOf(measureTypes[i]) < 0) {
                            MeasureReportModel.getSearchCriteria().measureTypes.push(measureTypes[i]);
                        }
                    }
                }
                if ($stateParams.ad){
                    if ($stateParams.frm === 'adcoLookup') {
                        MeasureReportModel.getSearchCriteria().additionalCode = $stateParams.ad;
                    } else {
                        var additionalCodes = $stateParams.ad.split(',');
                        for (let i = 0; i < additionalCodes.length; i++) {
                            if (MeasureReportModel.getSearchCriteria().additionalCodes.indexOf(additionalCodes[i]) < 0) {
                                MeasureReportModel.getSearchCriteria().additionalCodes.push(additionalCodes[i]);
                            }
                        }
                    }
                }
                if ($stateParams.fn){
                    if ($stateParams.frm === 'footnoteLookup') {
                        MeasureReportModel.getSearchCriteria().footnote = $stateParams.fn;
                    } else {
                        var footnotes = $stateParams.fn.split(',');
                        for (let i = 0; i < footnotes.length; i++) {
                            if (MeasureReportModel.getSearchCriteria().footnotes.indexOf(footnotes[i]) < 0) {
                                MeasureReportModel.getSearchCriteria().footnotes.push(footnotes[i]);
                            }
                        }
                    }
                }
                if ($stateParams.ce){
                    if ($stateParams.frm === 'certificateLookup') {
                        MeasureReportModel.getSearchCriteria().certificate = $stateParams.ce;
                    } else {
                        var certificates = $stateParams.ce.split(',');
                        for (let i = 0; i < certificates.length; i++) {
                            if (MeasureReportModel.getSearchCriteria().certificates.indexOf(certificates[i]) < 0) {
                                MeasureReportModel.getSearchCriteria().certificates.push(certificates[i]);
                            }
                        }
                    }
                }
                if ($stateParams.gnd) {
                    MeasureReportModel.getSearchCriteria().goodsNomenclatureDescription = $stateParams.gnd === 'true';
                }
                if ($stateParams.add) {
                    MeasureReportModel.getSearchCriteria().additionalCodeDescription = $stateParams.add === 'true';
                }
                if ($stateParams.fnd) {
                    MeasureReportModel.getSearchCriteria().footnoteDescription = $stateParams.fnd === 'true';
                }
                if ($stateParams.ced) {
                    MeasureReportModel.getSearchCriteria().certificateDescription = $stateParams.ced === 'true';
                }
                if ($stateParams.gad) {
                    MeasureReportModel.getSearchCriteria().geographicalAreaDescription = $stateParams.gad === 'true';
                }
                if ($stateParams.ded) {
                    MeasureReportModel.getSearchCriteria().dutyExpressionDescription = $stateParams.ded === 'true';
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            countries: function(MeasureReportModel, GeographicalAreaModel, $stateParams){
                var result = null;
                // Only get countries to support bookmark when there are required parameters.
                if ((!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' ||
                    $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup' || $stateParams.frm !== 'ccView') &&
                    $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.l &&
                    ($stateParams.mt || $stateParams.ad || $stateParams.fn || $stateParams.ce)) {

                    result = GeographicalAreaModel.getCountriesOfOrigin(MeasureReportModel.getSearchCriteria().startDate);
                }
                return result;
            },
            measureTypes: function(MeasureReportModel, MeasureTypeModel){
                return MeasureTypeModel.getMeasureTypes(MeasureReportModel.getSearchCriteria().direction,
                                                        MeasureReportModel.getSearchCriteria().startDate,
                                                        MeasureReportModel.getSearchCriteria().endDate);
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/measure');
                $translatePartialLoader.addPart('taric/quota');
            },
            setupMenu: function (MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    }).state('taric.report.measureAmendments', {
        url: '/measureamendments?frm&cc&ccField&ds&de&ccs&cce&d&mt&ut&ad&fn&ce&gnd&add&fnd&ced&ded&l',
        templateUrl: 'taric/report/measureamendments/measure-amendments-search.tmpl.html',
        controller : 'MeasureAmendmentsController as measureAmendmentsCtrl',
        reloadOnSearch: false,
        resolve: {
            initializeData: function($stateParams, $filter, $translate, MeasureAmendmentsModel, CommonHelper){
                if ($stateParams.frm !== 'ccLookup' &&
                    $stateParams.frm !== 'adcoLookup' &&
                    $stateParams.frm !== 'footnoteLookup' &&
                    $stateParams.frm !== 'certificateLookup') {
                    MeasureAmendmentsModel.reset();
                } else if ($stateParams.frm === 'ccLookup' ||
                    $stateParams.frm === 'adcoLookup' ||
                    $stateParams.frm === 'footnoteLookup' ||
                    $stateParams.frm === 'certificateLookup') {
                    MeasureAmendmentsModel.resetSearchResult();
                }
                if ($stateParams.ccField && $stateParams.cc){
                    if ($stateParams.ccField === 'commodityCodeRangeStart'){
                        MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                    } else if ($stateParams.ccField === 'commodityCodeRangeEnd'){
                        MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                    }
                }
                if ($stateParams.ds){
                    var startDate = CommonHelper.parseInputDate($stateParams.ds);
                    if (startDate) {
                        MeasureAmendmentsModel.getSearchCriteria().startDate = startDate;
                    }
                }
                if ($stateParams.de){
                    var endDate = CommonHelper.parseInputDate($stateParams.de);
                    if (endDate) {
                        MeasureAmendmentsModel.getSearchCriteria().endDate = endDate;
                    }
                }
                if ($stateParams.ccs) {
                    MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                }
                if ($stateParams.cce) {
                    MeasureAmendmentsModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                }
                if($stateParams.d){
                    if ($stateParams.d === 'I' || $stateParams.d === 'E'){
                        MeasureAmendmentsModel.getSearchCriteria().direction = $stateParams.d;
                    }
                }
                if ($stateParams.mt) {
                    MeasureAmendmentsModel.getSearchCriteria().measureType = $stateParams.mt;
                }
                if ($stateParams.ut){
                    if ($stateParams.ut === 'I' || $stateParams.ut === 'U' || $stateParams.ut === 'D') {
                        MeasureAmendmentsModel.getSearchCriteria().updateType = $stateParams.ut;
                    }
                }
                if ($stateParams.ad){
                    if ($stateParams.ad === '7XXX') {
                        // Return from meursing search with additional code
                        // Dummy value for "not selected"
                        MeasureAmendmentsModel.getSearchCriteria().additionalCode = null;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCode = $stateParams.ad;
                    }
                }
                if ($stateParams.fn){
                    MeasureAmendmentsModel.getSearchCriteria().footnote = $stateParams.fn;
                }
                if ($stateParams.ce){
                    MeasureAmendmentsModel.getSearchCriteria().certificate = $stateParams.ce;
                }
                if ($stateParams.gnd) {
                    if ($stateParams.gnd === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().goodsNomenclatureDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().goodsNomenclatureDescription = false;
                    }
                }
                if ($stateParams.add) {
                    if ($stateParams.add === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCodeDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().additionalCodeDescription = false;
                    }
                }
                if ($stateParams.fnd) {
                    if ($stateParams.fnd === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().footnoteDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().footnoteDescription = false;
                    }
                }
                if ($stateParams.ced) {
                    if ($stateParams.ced === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().certificateDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().certificateDescription = false;
                    }
                }
                if ($stateParams.ded) {
                    if ($stateParams.ded === 'true') {
                        MeasureAmendmentsModel.getSearchCriteria().dutyExpressionDescription = true;
                    } else {
                        MeasureAmendmentsModel.getSearchCriteria().dutyExpressionDescription = false;
                    }
                }
                if ($stateParams.l){
                    $translate.use($stateParams.l);
                }
            },
            measureTypes: function(MeasureAmendmentsModel, MeasureTypeModel){
                return MeasureTypeModel.getMeasureTypes(MeasureAmendmentsModel.getSearchCriteria().direction,
                    MeasureAmendmentsModel.getSearchCriteria().startDate,
                    MeasureAmendmentsModel.getSearchCriteria().endDate);
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/report/measureamendments');
            },
            setupMenu: function (MenuModel) {
                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    });
});



// WEBPACK FOOTER //
// ./app/taric/report/taric-report.js